import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { EMPTY_CELL_VALUE } from '../../../../NRReactGridCustomComponents/CellComponent/CellComponent';
import { getUserDisplayInitials } from '../../../../../utils/utils';

function NRJiraTicketAssigneeFormatter({ value, row }) {
  const theme = useTheme();

  if (value == null || value === '') {
    return EMPTY_CELL_VALUE;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), minWidth: 0 }}>
      <Avatar
        src={row?.assigneeAvatarUrl || undefined}
        alt={value}
        sx={{ width: theme.spacing(2.5), height: theme.spacing(2.5), fontSize: 10, flexShrink: 0 }}
      >
        {getUserDisplayInitials(value)}
      </Avatar>
      <Typography variant="body2" color="text.primary" noWrap>
        {value}
      </Typography>
    </Box>
  );
}

export function NRJiraTicketAssigneeProvider(props) {
  return <DataTypeProvider formatterComponent={NRJiraTicketAssigneeFormatter} {...props} />;
}
